/* eslint-disable no-underscore-dangle */
/* eslint-disable no-param-reassign */
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { actions } from '../../../redux';
import {
  CUSTOM_TEXT,
  eventBus,
  FABRIC_CUSTOM_OBJECT,
  getCurrentState,
  getLineOfControlPoint,
  getTextSize,
  GROUP,
  ITEXT,
  SUBTYPE_TEXT_COMPONENT,
  TEXTBOX,
  TEXT_COMPONENT,
  TEXT_GROUP_ID,
} from '../../../utils';

let timeout;
export default () => {
  const dispatch = useDispatch();
  const componentSettings = useSelector((appState) => appState.board.componentSettings);
  const activeType = useSelector((state) => state.board.activeType);
  const [state, _setState] = useState({
    canvas: null,
    editText: {},
  });
  const [text, setEditText] = useState(null);

  const initCanvas = (canvas) => _setState({ canvas });

  const handleSelectionStyle = (styles, dataText) => {
    clearTimeout(timeout);
    if (styles.length) {
      let result = {};
      const atts = [
        'fill',
        'fontSize',
        'textBackgroundColor',
        'fontFamily',
        'fontWeight',
        'fontStyle',
        'textAlign',
        'linethrough',
        'listType',
        'underline',
        'simulateList',
      ];
      atts.forEach((item) => {
        const isSameStyle = styles.every((i) => i[item] === styles[0][item]);
        if (!isSameStyle) {
          result = { ...result, [item]: undefined };
        } else if (['listType', 'simulateList'].includes(item)) {
          const obj = window.canvas ? window.canvas.getActiveObject() : null;
          if (!obj) return;
          result = { ...result, listType: obj.listType, simulateList: obj.simulateList };
        } else if (['textAlign'].includes(item)) {
          const obj = window.canvas ? window.canvas.getActiveObject() : null;
          if (!obj) return;
          result = { ...result, textAlign: obj.textAlign };
        } else if (['background'].includes(item)) {
          result = { ...result, textBackgroundColor: styles[0][item] };
        } else {
          result = { ...result, [item]: styles[0][item] };
        }
      });
      timeout = setTimeout(() => {
        eventBus.emit('on-update-settings-form', { style: result, text: dataText });
      }, 200);
    }
  };

  const getAllStyles = (textObj) => {
    let allStyles = [];
    for (let i = 0; i < Object.values(textObj.styles).length; i += 1) {
      const filterStyles = Object.values(textObj.styles[i]);
      if (Object.values(textObj.styles).length > 1) {
        filterStyles.pop();
      }
      allStyles = allStyles.concat(filterStyles);
    }
    return allStyles;
  };

  const checkAllEquals = (key, value, textObj) => {
    const allStyles = getAllStyles(textObj);
    if (allStyles.length === textObj.text.replace(/[\r\n]/gm, '').length) {
      const values = allStyles.reduce((a, c) => a.concat(c[key]), []);
      return values.every((v) => v === value);
    }
    return false;
  };

  const onChangeEditText = (data) => {
    setEditText(data.editText);
    handleSelectionStyle(data.editStyle || [], data.editText || null);
  };

  useEffect(() => {
    eventBus.on('on-change-edit-text', onChangeEditText);
    return () => {
      eventBus.off('on-change-edit-text', onChangeEditText);
    };
  }, []);

  const handleComponentsSetting = (obj, textSelection, styleEdited) => {
    let renderList = null;
    if (obj) {
      const { unorderList, orderList } = styleEdited;
      const renderText = obj._renderTextLine;
      Object.keys(styleEdited).forEach((item) => {
        switch (item) {
          case 'subscript':
            if (styleEdited.subscript) {
              textSelection.setSubscript();
              textSelection._renderTextLine = renderText;
            } else {
              const edit = textSelection.getSelectionStyles(
                textSelection.selectionStart,
                textSelection.selectionStart + 1,
                true,
              );
              textSelection.setSelectionStyles({
                fontSize: edit[0].fontSize / 0.6,
                deltaY: 0,
              });
            }
            break;
          case 'superscript':
            if (styleEdited.superscript) {
              textSelection.setSuperscript();
              textSelection._renderTextLine = renderText;
            } else {
              const edit = textSelection.getSelectionStyles(
                textSelection.selectionStart,
                textSelection.selectionStart + 1,
                true,
              );
              textSelection.setSelectionStyles({
                fontSize: edit[0].fontSize / 0.6,
                deltaY: 0,
              });
            }
            break;
          case 'orderList':
            if (styleEdited.orderList) {
              const { simulateList, listType, lineOffset } = styleEdited;
              obj.setSelectionStyles(
                {
                  simulateList,
                  listType,
                  lineOffset,
                },
                0,
                obj.text.length,
              );
              obj.simulateList = simulateList;
              obj.listType = listType;
              obj._getLineLeftOffset = lineOffset;
              renderList = orderList || renderText;
            }
            break;
          case 'unorderList':
            if (styleEdited.unorderList) {
              const { simulateList, listType, lineOffset } = styleEdited;
              obj.setSelectionStyles(
                {
                  simulateList,
                  listType,
                  lineOffset,
                },
                0,
                obj.text.length,
              );
              obj.simulateList = simulateList;
              obj.listType = listType;
              obj._getLineLeftOffset = lineOffset;
              renderList = unorderList || renderText;
            }
            break;
          default:
            if (
              textSelection &&
              !(textSelection.selectionEnd === textSelection.text.length && textSelection.selectionStart === 0)
            ) {
              if (styleEdited[item] !== '') {
                textSelection.setSelectionStyles({ [item]: styleEdited[item] });
                textSelection._renderTextLine = renderText;
              }
              if (obj.styles[0] == null) return;
              const firstStyleValue = Object.values(obj.styles[0])[0][item];
              const isEveryStyle = checkAllEquals([item], firstStyleValue, obj);
              if (isEveryStyle) {
                obj.set({ [item]: styleEdited[item] });
              } else if (getAllStyles(obj).length === obj.text.replace(/[\r\n]/gm, '').length) {
                obj.set({ [item]: '' });
              }
            } else {
              obj.set({ [item]: styleEdited[item] });
              if (styleEdited[item] !== '') {
                obj.setSelectionStyles({ [item]: styleEdited[item] }, 0, obj.text.length);
                obj._renderTextLine = renderText;
              }
            }
            break;
        }
        if (renderList) obj._renderTextLine = renderList;
        window.canvas.renderAll();
      });
    }
  };

  const resetSubSuper = (textSelection, obj) => {
    textSelection.setSelectionStyles({
      fontSize: obj.fontSize,
      deltaY: 0,
    });
  };

  const updateTextStyle = (obj, textSelection, styleEdited) => {
    let renderList = null;
    if (obj) {
      const { unorderList, orderList } = styleEdited;
      const renderText = obj._renderTextLine;
      const activeObj = window.canvas.getActiveObject();
      Object.keys(styleEdited).forEach((item) => {
        switch (item) {
          case 'subscript':
          case 'superscript':
            if (!styleEdited.ignoreSubSuper) {
              if (styleEdited.subscript || styleEdited.superscript) {
                resetSubSuper(textSelection, obj);
                if (styleEdited.subscript) textSelection.setSubscript();
                else textSelection.setSuperscript();
                textSelection._renderTextLine = renderText;
              } else {
                resetSubSuper(textSelection, obj);
              }
            }
            break;
          case 'orderList':
          case 'unorderList':
            if (styleEdited.orderList || styleEdited.unorderList) {
              const { simulateList, listType, lineOffset } = styleEdited;
              obj.setSelectionStyles(
                {
                  simulateList,
                  listType,
                  lineOffset,
                },
                0,
                obj.text.length,
              );
              obj.simulateList = simulateList;
              obj.listType = listType;
              obj._getLineLeftOffset = lineOffset;
              renderList = (styleEdited.orderList ? orderList : unorderList) || renderText;
            }
            break;
          case 'opacity':
            if (styleEdited.opacity) {
              const { opacity } = styleEdited;
              obj.set({ opacity });
            }
            break;
          case 'textAlign':
            break;
          default:
            if (styleEdited[item] === '' || styleEdited[item] === undefined || item === 'ignoreSubSuper') break;
            if (textSelection && [TEXTBOX, ITEXT].includes(activeObj?.type)) {
              if (textSelection.selectionStart === 0 && textSelection.selectionEnd === textSelection.text.length) {
                obj.set({ [item]: styleEdited[item] });
              }
              textSelection.setSelectionStyles({ [item]: styleEdited[item] });
              textSelection._renderTextLine = renderText;
            } else {
              obj.set({ [item]: styleEdited[item] });
              obj.setSelectionStyles({ [item]: styleEdited[item] }, 0, obj.text.length);
              obj._renderTextLine = renderText;
            }
            break;
        }
        if (renderList) obj._renderTextLine = renderList;
        window.canvas.renderAll();
      });
    }
  };

  useEffect(() => {
    if (componentSettings && window.canvas) {
      const obj = state.canvas.getActiveObject();
      if (!obj) return;
      const isControlPointOfOldArrowLine =
        obj?.diagramConnector?.name === FABRIC_CUSTOM_OBJECT.arrowLine ||
        obj?.diagramConnector?.name === FABRIC_CUSTOM_OBJECT.line ||
        obj?.diagramConnector?.name === FABRIC_CUSTOM_OBJECT.verticalLine ||
        obj?.diagramConnector?.name === FABRIC_CUSTOM_OBJECT.horizontalLine;
      if ([TEXTBOX, ITEXT].includes(activeType)) {
        updateTextStyle(obj, text, componentSettings);
        if (obj.isLabelComponent) {
          const { textWidth } = getTextSize(obj.text, JSON.parse(JSON.stringify(obj)));
          if (textWidth > obj.width) {
            obj.set({ width: textWidth });
          }
        }
        window.canvas.renderAll();
      } else {
        if (obj.id?.includes(TEXT_GROUP_ID) || obj.type === CUSTOM_TEXT || obj.type === TEXT_COMPONENT) {
          const textComponent = obj?._objects.find((o) => [TEXTBOX, ITEXT].includes(o.type));
          const container = obj._objects[0];
          container.set(componentSettings);
          updateTextStyle(textComponent, text, componentSettings.textSettings);
          if (obj.type === CUSTOM_TEXT) {
            const { textWidth } = getTextSize(textComponent.text, JSON.parse(JSON.stringify(textComponent)));
            obj.updateLabelComponent(textWidth);
          }
        } else if (obj.type === GROUP && obj.subType === SUBTYPE_TEXT_COMPONENT) {
          const container = obj._objects[0];
          container.set(componentSettings);
        } else if (obj.type === GROUP && obj?._objects.length === 1) {
          obj._objects[0].set(componentSettings);
        } else if (isControlPointOfOldArrowLine) {
          const newObj = getLineOfControlPoint(obj);
          newObj.set(componentSettings);
        } else {
          obj.set(componentSettings);
        }
        window.canvas.renderAll();
      }
      dispatch(actions.updatePageContent(getCurrentState()));
    }
  }, [componentSettings, text]);

  useEffect(() => {
    eventBus.on('handle-setting', handleComponentsSetting);
    return () => {
      eventBus.off('handle-setting', handleComponentsSetting);
    };
  }, [componentSettings]);

  return {
    initCanvas,
  };
};
